import React, { Component } from "react";
import "./VerifyEmail.css";
import { FaCheck } from "react-icons/fa";
import { IoIosClose } from "react-icons/io";
import Colors from "../../constants/Colors";
import firebase from "../../firebase/firebase";
import ClipLoader from "react-spinners/ClipLoader";
import { useTranslation } from "react-i18next";

interface IState {
  loading: boolean;
  status: "success" | string;
}

type Props = {
  oobCode: string;
};

export default class VerifyEmail extends Component<Props> {
  state: Readonly<IState> = {
    loading: true,
    status: "",
  };

  componentDidMount() {
    let that = this;
    firebase
      .auth()
      .applyActionCode(this.props.oobCode)
      .then(function (resp) {
        that.setState({
          loading: false,
          status: "success",
        });
      })
      .catch(function (error) {
        that.setState({
          loading: false,
          status: error,
        });
      });
  }

  renderContent() {
    if (this.state.status === "success") {
      return <SuccessMessage />;
    } else {
      return <ErrorMessage />;
    }
  }

  render() {
    return (
      <div className={"mainContainer"}>
        {!this.state.loading && this.renderContent()}
        <ClipLoader
          size={80}
          color={Colors.mainColor}
          loading={this.state.loading}
        />
      </div>
    );
  }
}

function SuccessMessage() {
  const { t } = useTranslation();

  return (
    <div className={"innerContent"}>
      <div className={"iconContainer backgroundGreenColor"}>
        <FaCheck color={Colors.white} size={30} />
      </div>

      <div className={"messageContainer"}>
        <h2 style={{ fontWeight: 400 }}>{t("auth.successfulVerification")}</h2>
      </div>
    </div>
  );
}

function ErrorMessage() {
  const { t } = useTranslation();

  return (
    <div className={"innerContent"}>
      <div className={"iconContainer backgroundMainColor"}>
        <IoIosClose color={Colors.white} size={90} />
      </div>

      <div className={"messageContainer"}>
        <h2 style={{ fontWeight: 400 }}>{t("auth.linkIsNotValid")}</h2>
        <h3>{t("auth.emailVerificationErrorMessage")}</h3>
      </div>
    </div>
  );
}
